var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShellfishIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.156,
    height: 69.198,
    viewBox: "0 0 76.156 69.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-118.663 -13.731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.646,49.9l-.007.007a5.337,5.337,0,0,0,.83,7.727l28.593,21.662a9.406,9.406,0,0,0,11.358,0L191.013,57.63a5.336,5.336,0,0,0,.83-7.727l-.007-.007a5.337,5.337,0,0,0-5.709-1.6",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.748,65.3l19.041-18.718a6.618,6.618,0,0,0-.576-9.943h0a6.62,6.62,0,0,0-6.963-.726",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.735,65.3,125.072,45.967a6.205,6.205,0,0,1,.264-9.095h0a6.181,6.181,0,0,1,3.193-1.471",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.969,61.26l15.553-27.217a8.494,8.494,0,0,0-1.433-10.285h0a8.495,8.495,0,0,0-11.953.066",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.461,21.293a8.475,8.475,0,0,0-6.316,2.158h0A9.077,9.077,0,0,0,133.335,34.7l15.178,26.56",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.215,58.909l-6.672-30.854a10.434,10.434,0,0,1,10.2-12.638h0a10.434,10.434,0,0,1,10.2,12.638l-6.671,30.854",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5,81.243h5.423a3.526,3.526,0,0,0,3.436-2.733l2.9-12.548",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.232,65.962l2.9,12.548a3.526,3.526,0,0,0,3.436,2.733h5.423",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShellfishIcon);
export default __webpack_public_path__ + "static/media/shellfish-icon.2f24ef81.svg";
export { ForwardRef as ReactComponent };